import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { AppCrashError } from './AppCrashError.js';
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { errorState: undefined };
    }
    componentDidCatch(error, errorInfo) {
        const { reportId, reportURL } = this.props.sendErrorReportFn(error, {
            metadata: { react: { componentStack: errorInfo.componentStack } },
            unhandled: true,
        }) ?? {};
        this.setState({
            errorState: {
                error,
                reportId,
                reportURL,
            },
        });
    }
    render() {
        const { errorState } = this.state;
        if (errorState) {
            return (_jsx(AppCrashError, { error: errorState.error, errorId: errorState.reportId, errorUrl: errorState.reportURL }));
        }
        return this.props.children;
    }
}
//# sourceMappingURL=ErrorBoundary.js.map